import React from "react"
import InfoWithImageSectionDesktop from "./InfoWithImageSectionDesktop"
import InfoWithImageSectionrMobile from "./InfoWithImageSectionrMobile"
import { useMediaQuery } from "react-responsive"
import { InfoWithImageSectionProps } from "@/app/interface/components"

const InfoWithImageSection: React.FC<InfoWithImageSectionProps> = ({ href="/contato", justifyContent, hasButton=false, isDropdown=false, title, text, img, contentDropdown=[], flexDirection="row", loading="eager", isIntro=false, imgHeightFixed=false, width, height }) => {
    const isDesktop = useMediaQuery({ minWidth: 1140 })
    
    return (
        <>
            {
                isDesktop ? (
                    <InfoWithImageSectionDesktop href={href} justifyContent={justifyContent} isIntro={isIntro} hasButton={hasButton} isDropdown={isDropdown} title={title} text={text} img={img} contentDropdown={contentDropdown} flexDirection={flexDirection} loading={loading} imgHeightFixed={imgHeightFixed} width={width} height={height} />
                ) : (
                    <InfoWithImageSectionrMobile href={href} isIntro={isIntro} hasButton={hasButton} isDropdown={isDropdown} title={title} text={text} img={img} contentDropdown={contentDropdown} flexDirection={flexDirection} loading={loading} width={width} height={height} />
                )
            }
        </>
    )
}

export default React.memo(InfoWithImageSection)